export default __webpack_public_path__ + "static/media/Mark-4-3D-Model-01.7ca6112b.jpg";